import styled from '@emotion/styled';
import { blueActiveColor, blueDisabledColor, blueEnabledColor, blueHoverColor, white } from './colors';

export const MobileButton = styled.div((props) => {
  let style = {
    display: 'block',
    color: white,
    width: '80%',
    marginLeft: '10%',
    height: '44px',
    paddingTop: '11px',
    fontSize: '17px',
    fontWeight: '500',
    borderRadius: '24px',
    textAlign: 'center',
    letterSpacing: '1px',
    cursor: 'pointer',
    backgroundColor: blueEnabledColor,
    ':hover': {
      backgroundColor: blueHoverColor
    },
    ':hover:active': {
      backgroundColor: blueActiveColor
    }
  };
  if (props.disabled) {
    style.backgroundColor = blueDisabledColor;
    style.pointerEvents = 'none';
  }
  return style;
});



// WEBPACK FOOTER //
// ./src/styles/MobileButton.js